<template>
  <PopupBackground v-if="showVerifyEmailPopup">
    <div
      class="flex-center flex-col bg-secondary pad-30 br-5 smooth-shadow w-400"
    >
      <div class="flex-col flex-center success">
        <img class="success-image" src="@/assets/verify_email.svg" alt="" />
        <h3>We have sent you a verification link!</h3>
        <h4 class="caption">
          Verify your email by clicking on the link provided in the email
        </h4>
        <button class="button mar-top-20" @click="gotoLogin()">
          Okay, Got it!
        </button>
      </div>
    </div>
  </PopupBackground>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";

import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    success: Boolean,
  },
  components: {
    PopupBackground,
  },
  computed: {
    ...mapGetters("Popup", ["showVerifyEmailPopup"]),
  },
  methods: {
    ...mapActions("Popup", ["toggleVerifyEmailPopup"]),
    gotoLogin() {
      this.toggleVerifyEmailPopup();
      this.$router.push("/auth");
    },
  },
};
</script>

<style lang="scss" scoped>
.w-500 {
  width: 500px;
}
.success {
  .success-image {
    width: 200px;
    height: auto;
    margin-bottom: 20px;
  }

  .caption {
    opacity: 0.7;
    margin-top: 10px;
  }
}
</style>
